import React, {PropTypes} from "react";
import {connect} from 'react-redux';

class FeedbackSmileys extends React.Component {
	render() {
        const {label,id,required,answerList} = this.props;

        const answerItems = answerList.map((answer) =>
           <li  onClick={()=>{
             this.props.onChange({id: answer.id,value: answer.value});
           }} className={answer.id == this.props.active?"active":"inactive"}>
                <input type="radio"

                    name="rating"
                    value={answer.value}
                    id={answer.id}
                    />
                <label>{answer.id}</label>
                <span className="emotion-text">{answer.value}</span>
            </li>
        );


			return (
                    <div className="step-one text-center">
                        <h2>{label}</h2>
                        <ul className="rating" onClick={()=>{
                          console.log("got clicked");
                        }}>
                              {answerItems}
                        </ul>
                    </div>
);
	}
}
export default FeedbackSmileys;



/** WEBPACK FOOTER **
 ** ./src/feature/feedback/feedbackSmileys.js
 **/